import { colord, extend } from 'colord';
import namesPlugin from 'colord/plugins/names';
import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';
extend([namesPlugin]);

export const ColorSwatch = ({ value, id, size }: { value?: string | null; id?: string; size?: number }) => {
  const isMixed = value === null;
  const isGradient = value?.includes('gradient');
  const rgba = colord(value || 'transparent').toRgb();
  const isFullyTrasparent = rgba.a === 0;
  const isSolid = rgba.a === 1;
  const alphaPercent = Math.round(rgba.a * 100);
  rgba.a = 1;
  const noAlphaColor = colord(rgba).toHex();

  const showLeftSwatch = !isGradient && !isFullyTrasparent;
  const showRightSwatch = !isFullyTrasparent || !isSolid;
  const tooltipContent = value ? (isGradient ? 'Gradient' : isSolid ? value : `${value} ${alphaPercent}%`) : '';

  return (
    <Container id={id} $size={size}>
      <SwatchContainer>
        <Checkboard $size={size} />
        <ColorPreviewContainer>
          {/* No alpha color */}
          {showLeftSwatch && <Swatch style={{ background: noAlphaColor }} />}
          {/* Direct color */}
          {showRightSwatch && <Swatch style={{ background: value || undefined }} />}
        </ColorPreviewContainer>
        {isMixed && <MixedIndicator />}
      </SwatchContainer>

      <Border />
      <Tooltip anchorSelect={'#' + id} place="bottom" content={tooltipContent} delayShow={1000} />
    </Container>
  );
};

const Container = styled.div<{ $size?: number }>`
  position: relative;
  width: ${({ $size }) => ($size ? `${$size}px` : '26px')};
  min-width: ${({ $size }) => ($size ? `${$size}px` : '26px')};
  height: ${({ $size }) => ($size ? `${$size}px` : '26px')};
  min-height: ${({ $size }) => ($size ? `${$size}px` : '26px')};
`;

const Border = styled.div`
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  box-sizing: border-box;
  width: calc(100%);
  height: calc(100%);

  border-radius: var(--radius-2);
  outline: 2px solid var(--neutral-2);

  &:hover {
    outline: 2px solid var(--neutral-3);
  }
`;

const SwatchContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const ColorPreviewContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
`;

const Swatch = styled.div`
  width: 100%;
  height: 100%;
`;

const Checkboard = styled.div<{ $size?: number }>`
  position: relative;
  width: ${({ $size }) => ($size ? `${$size}px` : '26px')};
  height: ${({ $size }) => ($size ? `${$size}px` : '26px')};

  background: url('data:image/svg+xml;utf8,<svg preserveAspectRatio="none"  viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="5" height="5" fill="grey" /><rect x="5" y="5" width="5" height="5" fill="grey" /><rect x="5" y="0" width="5" height="5" fill="white" /><rect x="0" y="5" width="5" height="5" fill="white" /></svg>')
    0 0 / ${({ $size }) => ($size ? `${$size / 2}px ${$size / 2}px` : '13px 13px')};
`;

const MixedIndicator = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 26px;
  height: 26px;
  background-color: #000000aa;
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 2px;
    height: 100%;
    background-color: var(--primary-1);
  }
  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;